import IsIos from '@/mixins/is-ios.js'
import formValidator from '@/mixins/form-validator.js'
import toastStore from '@/stores/toast-store.js'
import logo from '@/assets/images/collectomate-logo.png'
import acceptance from '@/validators/acceptance.js'
import { required, requiredIf } from 'vuelidate/lib/validators'
import axios from 'axios'

import TermsOfUseModal from '@/vcs/_shared/modals/terms-of-use/cmp.vue'
import MbankTermsOfUseModal from '@/vcs/_shared/modals/mbank-terms-of-use/cmp.vue'

export default {
  name: 'SetPassword',
  mixins: [IsIos, formValidator],
  data: function () {
    return {
      errors: {},
      submitted: false,
      logo: logo,

      user: {
        password: '',
        passwordConfirmation: '',
        resetPasswordToken: '',
        termsAgreement: false,
        mbankPasswordAgreement: false,
      },

      blocker: false,
      validatedItemKey: 'user',

      newPasswordInputType: 'password',
      repeatPasswordInputType: 'password',
    }
  },
  methods: {
    setPassword: function (e) {
      console.log('CURRENT ROUTE', this.$router.currentRoute)
      this.user.resetPasswordToken = this.$router.currentRoute.params.token
      e.preventDefault()
      this.submitted = true
      this.validateForm()

      if (Object.keys(this.errors).length > 0) {
        toastStore.commit('error', {
          message: this.$t('messages.validationErrorFillFields'),
        })
      } else {
        this.blocker = true
        axios({
          method: 'post',
          url: 'auth/reset_password',
          data: this.user,
        })
          .then(() => {
            alert('Twoje hasło zostało zmienione, możesz się teraz zalogować.')
            this.$router.push('/')
          })
          .catch(error => {
            if (error.response.data.errors.flow) {
              this.$errorHumanized({ error })
            } else {
              let errorMessage
              if (error.response.status == 422) {
                this.errors = { ...error.response.data.errors }
                errorMessage = (error.response.data.errors || {}).base
                  ? error.response.data.errors.base.join(', ')
                  : this.$t('messages.error')
              } else {
                errorMessage = this.$t('messages.error')
              }
              toastStore.commit('error', { message: errorMessage })
            }
          })
          .finally(() => {
            this.blocker = false
          })
      }
    },
    showTermsOfUse() {
      if (this.$isMbank) {
        this.$store.commit('modal/open', {
          cmp: MbankTermsOfUseModal,
          animation: 'slide-down-menu',
        })
      } else {
        this.$store.commit('modal/open', {
          cmp: TermsOfUseModal,
          animation: 'slide-down-menu',
        })
      }
    },
    showPasswordHandler(type) {
      this[type] = 'text'
    },
    hidePasswordHandler(type) {
      this[type] = 'password'
    },
  },
  validations() {
    if (this.submitted) {
      return {
        user: {
          password: {
            required,
          },
          passwordConfirmation: {
            required,
            mbankPasswordComplexity: function (value) {
              if (this.$isMbank) {
                return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{0,}$/.test(
                  value,
                )
              } else {
                return true
              }
            },
            mbankPasswordLength: function (value) {
              if (this.$isMbank) {
                return value.length >= 12
              } else {
                return true
              }
            },
          },
          termsAgreement: {
            required,
            acceptance,
          },
          mbankPasswordAgreement: {
            mbankChecked: function (value) {
              if (this.$isMbank) {
                return value
              } else {
                return true
              }
            },
          },
        },
      }
    } else {
      return {}
    }
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
